import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts';
import { Loading } from '../Loading';
import { useEffect } from 'react';

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard = ({ children }: AuthGuardProps) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Verificar token no localStorage e limpar se inválido
  useEffect(() => {
    const token = localStorage.getItem('token');
    
    // Se não há token mas isAuthenticated é true, há inconsistência
    if (!token && !isLoading && isAuthenticated) {
      console.warn('Token não encontrado mas usuário marcado como autenticado. Limpando estado...');
      localStorage.removeItem('auth-storage');
      window.location.href = '/login';
    }
  }, [isAuthenticated, isLoading]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loading message="Verificando autenticação..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};